import React from 'react';
import clsx from 'clsx';

export const InlineSnippet = ({ className, children }) => {
  return (
    <span
      className={clsx(
        'inline-block rounded-md bg-muted px-1 py-0.5 text-foreground',
        className,
      )}
    >
      {children}
    </span>
  );
};
